import { EtlHealthDashboard } from '../components/etl-health-dashboard';

const EtlDashboardTab = () => (
  <div className="flex flex-col gap-6 p-4 sm:p-6">
    <EtlHealthDashboard />
  </div>
);

export default EtlDashboardTab;
